<template>
<div class="self-center flex flex-col font-sans">
    <h1 class="text-grey-darker font-light text-2xl md:text-3xl lg:text-5xl">
        Ez a domain név eladó:
        <span class="font-medium border-b-4 border-indigo-light">{{ domainName }}</span>
    </h1>
    <h2 v-if="facebookPage.exists" class="text-grey-darker font-light text-lg md:text-xl lg:text-2xl mt-10">
        A hozzá tartozó facebook oldallal:
        <span class="font-medium">
            <a :href="facebookPage.url" :title="splitUrl" target="_blank" class="text-indigo-light no-underline hover:bg-indigo-light hover:text-white md:px-2">
                {{ splitUrl }}
            </a>
        </span>
    </h2>
    <div class="flex justify-center mt-16 lg:mt-32">
        <a :href="'mailto:' + email + '?subject=Eladó domain - ' + domainName" target="_blank" :title="email" class="text-xl md:text-2xl lg:text-3xl text-indigo-light no-underline hover:bg-indigo-light hover:text-white border-b border-indigo-light xl:border-b-0 p-4" v-on:mouseover="mailHover = true" v-on:mouseleave="mailHover = false">
            {{ mailHover ? email : 'Érdekel!'}}
        </a>
    </div>
</div>
</template>

<script>
export default {
    name: 'SellDomain',
    data: function () {
        return {
            email: 'info@codespot.hu',
            domainName: 'borsodisorfesztival.hu',
            facebookPage: {
                exists: true,
                url: 'https://www.facebook.com/borsodisorfeszt/',
            },
            mailHover: false,
        }
    },
    computed: {
            splitUrl: function() {
                let facebookUrl = new URL(this.facebookPage.url)
                return facebookUrl.host + facebookUrl.pathname
            }
    },
}
</script>
